import _ from 'underscore';
import { getPropertiesFromQueryString } from '../util/query-string';

const HotelBIGridsMetadata = {
  AdvancedBookingGrid: {
    specificProperty: 'AdvancedBookingWindow',
    routeFragment: 'advanced-booking',
    routeFragmentForNewUI: 'advancedbookinggrid',
  },
  CheckinDayGrid: {
    specificProperty: 'CheckinDay',
    routeFragment: 'checkin-day',
    routeFragmentForNewUI: 'checkindaygrid',
  },
  DateTypeGrid: {
    specificProperty: 'DateType',
    routeFragment: 'date-type',
    routeFragmentForNewUI: 'datetypegrid',
  },
  HotelCountryGrid: {
    specificProperty: 'HotelCountry',
    routeFragment: 'hotel-country',
    routeFragmentForNewUI: 'hotelcountrygrid',
  },
  HotelDeviceTypeGrid: {
    specificProperty: 'DeviceType',
    routeFragment: 'devicetype',
    routeFragmentForNewUI: 'hoteldevicetypegrid',
  },
  HotelDateGrid: {
    specificProperty: 'Date',
    routeFragment: 'date',
    routeFragmentForNewUI: 'hoteldategrid',
  },
  HotelLengthOfStayGrid: {
    specificProperty: 'LengthOfStay',
    routeFragment: 'length-of-stay',
    routeFragmentForNewUI: 'hotellengthofstaygrid',
  },
  HotelUserCountryGrid: {
    specificProperty: 'UserCountry',
    routeFragment: 'user-country',
    routeFragmentForNewUI: 'hotelusercountrygrid',
  },
  HotelSlotTypeGrid: {
    specificProperty: 'SlotType',
    routeFragment: 'slot-type',
    routeFragmentForNewUI: 'hotelslottypegrid',
  },
  SiteTypeGrid: {
    specificProperty: 'SiteType',
    routeFragment: 'site-type',
    routeFragmentForNewUI: 'sitetypegrid',
  },
};

export function getName({
  '@odata.type': ODataType,
  Type,
  QueryString = '',
}) {
  if (ODataType === '#Model.DimensionReportSelection') {
    switch (Type) {
      case 'VerticalPerformance': {
        const properties = getPropertiesFromQueryString(QueryString);

        return _.findKey(
          HotelBIGridsMetadata,
          ({ specificProperty }) => _.contains(properties, specificProperty)
        );
      }
      case 'PerformanceTargetReport': {
        if (QueryString.indexOf('PerformanceTargetName') >= 0) {
          return 'PerformanceTargetsSummaryGrid';
        }
        return 'PerformanceTargetHistoryGrid';
      }
      case 'CampaignLabelReport':
        return '1Grid';
      case 'AdGroupLabelReport':
        return '2Grid';
      case 'KeywordLabelReport':
        return '3Grid';
      case 'AdLabelReport':
        return '4Grid';
      case 'AccountLabelMccReport':
        return '5Grid';
      default:
        break;
    }
  }

  return null;
}

export function getPage({
  '@odata.type': ODataType,
  Type,
}) {
  if (ODataType === '#Model.DimensionReportSelection' && Type === 'VerticalPerformance') {
    return 'HotelCenter';
  }

  return 'Campaigns';
}

export function getRoute({
  '@odata.type': ODataType,
  Type,
  QueryString = '',
  ReportDataId = '',
}) {
  if (ODataType === '#Model.DimensionReportSelection') {
    switch (Type) {
      case 'VerticalPerformance': {
        const properties = getPropertiesFromQueryString(QueryString);

        const {
          routeFragment,
        } = _.find(
          HotelBIGridsMetadata,
          ({ specificProperty }) => _.contains(properties, specificProperty)
        );

        return `overview/grid-chooser-item-${routeFragment}`;
      }
      case 'PerformanceTargetReport': {
        if (QueryString.indexOf('PerformanceTargetName') >= 0) {
          return 'customer/:customer_id/account/:account_id/performance_target';
        }
        return `customer/:customer_id/account/:account_id/performance_target/${ReportDataId}/history`;
      }
      default:
        break;
    }
  }

  throw new Error('TODO: not implemented yet');
}

export function getRouteForNewUI({
  getUrlSearch,
  selection: {
    '@odata.type': ODataType,
    Type,
    QueryString = '',
    ReportDataId = '',
  },
}) {
  if (ODataType === '#Model.DimensionReportSelection') {
    switch (Type) {
      case 'VerticalPerformance': {
        const properties = getPropertiesFromQueryString(QueryString);

        const {
          routeFragmentForNewUI,
        } = _.find(
          HotelBIGridsMetadata,
          ({ specificProperty }) => _.contains(properties, specificProperty)
        );

        return `hotelcenter/overview/${routeFragmentForNewUI}${getUrlSearch()}`;
      }
      case 'PerformanceTargetReport': {
        if (QueryString.indexOf('PerformanceTargetName') >= 0) {
          return `performancetargets${getUrlSearch()}`;
        }
        return `performancetargets/history${getUrlSearch({ ptId: ReportDataId })}`;
      }
      case 'CampaignLabelReport':
        return `labelscampaign${getUrlSearch()}`;
      case 'AdGroupLabelReport':
        return `labelsadgroup${getUrlSearch()}`;
      case 'KeywordLabelReport':
        return `labelskeyword${getUrlSearch()}`;
      case 'AdLabelReport':
        return `labelsad${getUrlSearch()}`;
      case 'AccountLabelMccReport':
        return `labelsaccount${getUrlSearch()}`;
      default:
        throw new Error(`getRouteForNewUI: unsupported Type ${Type}`);
    }
  }

  throw new Error(`getRouteForNewUI: unsupported ODataType ${ODataType}`);
}

export function getColumnsMetadata() {
  return _.defaults({
    DateRange: ['StartDate', 'EndDate'],
  });
}
